module.exports = __webpack_public_path__ + "img/icons B_29.ca5b4d2f.svg";